export default {
  disablePageInteraction: false, // dark overlay, the page is not clickable until the user selects
  revision              : 1, // if you increase it, it asks for consent from everyone again
  hideFromBots          : true,
  cookie                : {name: `${import.meta.env.VITE_STORAGE_PREFIX}_cc`, expiresAfterDays: 365},
  guiOptions            : {
    consentModal: {
      layout            : 'box wide', // 'box' | 'box wide' | 'box inline' | 'cloud' | 'cloud inline' | 'bar' | 'bar inline'
      position          : 'bottom right', // 'top|middle|bottom' + 'left|center|right' (bar only 'top' ή 'bottom')
      equalWeightButtons: true, // equal weight in Acceptance and Rejection buttons (required by GDPR authorities)
      flipButtons       : false
    },
    preferencesModal: {
      layout            : 'box', // 'box' | 'bar' | 'bar wide'
      position          : 'right', // bar: 'left' | 'right'
      equalWeightButtons: true,
      flipButtons       : false
    }
  },

  categories: {
    necessary: {
      enabled : true,
      readOnly: true
    },
    analytics    : {},
    marketing    : {},
    notifications: {}
  },

  language: {
    default   : import.meta.env.VITE_I18N_LOCALE || 'el',
    autoDetect: 'document' // reads <html lang="">
  }
}
